/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize Potassium View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './PotassiumView';

export const mapStateToPropsPotassium = mapStateToProps;
export const mapDispatchToPropsPotassium = mapDispatchToProps;

export default connect(
  mapStateToPropsPotassium,
  mapDispatchToPropsPotassium
)(View);
